export enum SituacaoEnum {
  NaoConcluido = 1,
  Concluido = 2,
  ParaRevisao= 3
}
